/* eslint-disable no-param-reassign */
export default (
  state,
  {
    payload: {
      modal: { modalId, ...data },
    },
  }
) => {
  state[modalId] = {
    ...state[modalId],
    modalId,
    ...data,
  };
};
